import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { ProvisionChange } from '../../models/provisionchange';

@Pipe({
  standalone: false,
  name: 'sortadditionalchanges'
})

@Injectable()
export class SortAdditionalChangesPipe implements PipeTransform {
  transform(items: ProvisionChange[], IsInCSpec: boolean): any[] {
    if (!items) return [];
    if (items.length === 0) return [];
    let filteredAdditionals = items.filter(item => item.IsInCSpec == IsInCSpec);
    
    return filteredAdditionals;
  }
}